import { defineMessages, IntlFormatters } from "react-intl";

const folksongTempoMessages = defineMessages({
    parlando: {
        id: "meta.folksongTempo.parlando",
    },
    rubato: {
        id: "meta.folksongTempo.rubato",
    },
    giusto: {
        id: "meta.folksongTempo.giusto",
    },
});

export const folksongTempos = (fm: IntlFormatters["formatMessage"]) => {
    return [
        { value: "parlando", label: fm(folksongTempoMessages["parlando"]) },
        { value: "rubato", label: fm(folksongTempoMessages["rubato"]) },
        { value: "giusto", label: fm(folksongTempoMessages["giusto"]) },
    ];
};
